export const splitRequest = async (lazyQueryTrigerer, paramArray, paramKey, batchSize, additionalParams = '' ) => {
    // Divide the parameters into smaller chunks
    const chunks = [];
    for (let i = 0; i < paramArray.length; i += batchSize) {
        chunks.push(paramArray.slice(i, i + batchSize));
    }

    // Make requests for each chunk
    let allResults = [];
    for (const chunk of chunks) {
        const queryString = chunk.map(item => `${paramKey}=${item}`).join('&');
        const url = `?${queryString}${additionalParams ? '&' + additionalParams : ''}`;
        
        try {
            const result = await lazyQueryTrigerer(url).unwrap(); // Use unwrap to handle errors
            allResults = allResults.concat(result);
        } catch (error) {
            if (error.status == 401) return; // re-autentication managed automatically by middleware
            console.error('Request failed:', error);
            throw error;
        }
    }
    return allResults;
};

export const fetchAllPages = async (lazyQueryTrigger, dataArrayProperty = 'data', initialParams ) => {
    let allResults = [];
    let currentPage = 1;
    let hasMorePages = true;

    while (hasMorePages) {
        const params = { ...initialParams, page: currentPage }

        try {
            const result = await lazyQueryTrigger(params).unwrap();
            
            if (Array.isArray(result[dataArrayProperty])) {
                allResults = allResults.concat(result[dataArrayProperty]);
            } else {
                console.error('Unexpected response format:', result);
                break;
            }

            if (result.pageSize < result.totalCount && currentPage * result.pageSize < result.totalCount) {
                currentPage++;
            } else {
                hasMorePages = false;
            }
        } catch (error) {
            if (error.status === 401) return; // re-authentication managed automatically by middleware
            console.error('Request failed:', error);
            throw error;
        }
    }

    return allResults;
};

